<template>
  <el-dialog ref="dialog" custom-class="w-400 h-480 ovf-auto" title="选择新增列表">
    <div>
      <el-table
      :data="contentList"
      stripe
      style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="列表名称">
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template scope="scope">
            <template v-if="isSelected(scope.row.id) < 0">
              <el-button size="small" @click="selectOperation(scope.row)">选择</el-button>
            </template>
            <template v-else>
              <el-tooltip class="item" effect="dark" content="该列表已选择" placement="left">
                <el-button size="small" :disabled="true">选择</el-button>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    name: 'addList',
    props: {
      contentList: {
        type: Array,
        default() {
          return []
        }
      },
      ids: {
        type: Array,
        default() {
          return []
        }
      }
    },
    methods: {
      open() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      selectOperation(item) {
        if (item.type == 10) {
          setTimeout(() => {
            this.$emit('selectList', item)
          }, 0)
        } else if (item.type == 130) {
          setTimeout(() => {
            this.$emit('selectChart', item)
          }, 0)
        }
        this.closeDialog()
      },
      isSelected(id) {
        return this.ids.indexOf(id)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// addList.vue?89e4b9d4